<template>
<div class="chapter">
<div class="inner_page">
<p class="sgc-1"><span>© 2012 The Howard Zinn Revocable Trust</span></p>
<p class="sgc-1"><span>Introduction © 2012 by Anthony Arnove</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>Published in 2012 by</span></p>
<p class="sgc-1"><span>Haymarket Books</span></p>
<p class="sgc-1"><span>PO Box 180165</span></p>
<p class="sgc-1"><span>Chicago, IL 60618</span></p>
<p class="sgc-1"><span>www.haymarketbooks.org</span></p>
<p class="sgc-1"><span>773-583-7884</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>ISBN: 978-1-60846-228-5</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>Trade distribution:</span></p>
<p class="sgc-1"><span>In the US, Consortium Book Sales and Distribution, www.cbsd.com</span></p>
<p class="sgc-1"><span>In Canada, Publishers Group Canada, www.pgcbooks.ca</span></p>
<p class="sgc-1"><span>In the UK, Turnaround Publisher Services, www.turnaround-uk.com</span></p>
<p class="sgc-1"><span>In Australia, Palgrave Macmillan, www.palgravemacmillan.com.au</span></p>
<p class="sgc-1"><span>All other countries, Publishers Group Worldwide, www.pgw.com</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>Cover design by Abby Weintraub. Photo courtesy of the estate of Howard Zinn.</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>Published with the generous support of Lannan Foundation</span></p>
<p class="sgc-1"><span>and the Wallace Global Fund.</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>Library of Congress cataloging-in-publication data is available.</span></p>
<p class="sgc-1"> </p>
<p class="sgc-1"><span>10 9 8 7 6 5 4 3 2 1</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Flow_0_0002.vue?ea7e94da